import { TRIGGER_TYPE_LABEL } from "../../../features/builder.constants";
import { parseJsonObject } from "../../../features/builder.utils";

// Pure helpers of the Recipient Type tab (no API, no React).

/** The resolver a form is about. */
export const resolverOf = (formData, dependencies) => (dependencies?.resolvers || []).find((resolver) => resolver.id === formData?.type_key) ?? null;

/** "All triggers" for an empty list, else the trigger type labels. */
export const triggersText = (triggers) => (triggers?.length ? triggers.map((t) => TRIGGER_TYPE_LABEL[t] ?? t).join(", ") : "All triggers");

/** EntityFormModal values -> create / update payload. The config schema is sent only when "Edit config schema as JSON" is on. */
export const toRecipientTypePayload = (values, isEdit) => ({
  ...(isEdit ? {} : { type_key: values.type_key }),
  name: values.name?.trim() ?? "",
  description: values.description?.trim() || null,
  needs_subject: !!values.needs_subject,
  allowed_triggers: Array.isArray(values.allowed_triggers) ? values.allowed_triggers : [],
  sort_order: values.sort_order === "" || values.sort_order === null || values.sort_order === undefined ? 0 : Number(values.sort_order),
  is_activated: !!values.is_activated,
  ...(values.edit_schema && { config_schema: parseJsonObject(values.config_schema_text ?? "") ?? null }),
});
